<template>
  <div class="row mt-4">
    <div
      v-if="showSearch"
      class="col-6 col-lg-4"
    >
      <label
        class="hide"
        for="search"
      >Filterbegriff</label>
      <input
        id="search"
        v-model="search"
        class="form-control w-100 mb-4"
        placeholder="Liste filtern..."
        type="search"
      >
    </div>

    <div
      v-if="showSearch"
      class="col-6 col-lg-8"
    >
      <div class="text-right vertical-center">
        <b-link
          id="popover-button-open"
        >
          Nach Kategorie filtern
        </b-link>

        <b-popover
          class="my-2"
          placement="bottom"
          target="popover-button-open"
        >
          <button
            v-for="category in categories"
            :key="category.id"
            :class="{ active: category.active }"
            class="badge badge-pill badge-outline-primary ml-1 mt-2"
            style="font-size: 0.75rem;"
            @click="toggleCategory(category)"
          >
            {{ category.name }}
          </button>
          <div>
            <button
              class="btn-link m-2 mt-3 float-left small"
              @click="showNone"
            >
              (Keine auswählen)
            </button>
            <button
              class="btn-link m-2 mt-3  float-right small"
              @click="showAll"
            >
              (Alle auswählen)
            </button>
          </div>
        </b-popover>
      </div>
    </div>

    <div
      v-for="thirdParty in filteredListBySearch"
      :key="thirdParty.id"
      class="col-md-6 col-lg-4 col-12 mb-3"
    >
      <a
        :href="thirdParty.path"
        class="text-decoration-none"
      >

        <div class="card third-party-card shadow-sm h-100">
          <div class="card-body">
            <div class="row">
              <div
                class="col-sm-2 col-3 content-vertical-aligned"
              >
                <span class="icon-round icon-round-sm">
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 1"
                    :icon="['fal', 'chart-bar']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 2"
                    :icon="['fal', 'ad']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 3"
                    :icon="['fal', 'server']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 4"
                    :icon="['fal', 'users']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 5"
                    :icon="['fal', 'video']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 6"
                    :icon="['fal', 'credit-card']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 7"
                    :icon="['fal', 'envelope']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 8"
                    :icon="['fal', 'ellipsis-h-alt']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 9"
                    :icon="['fal', 'map-marked']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 10"
                    :icon="['fal', 'font']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 11"
                    :icon="['fal', 'coin']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 12"
                    :icon="['fal', 'user-tie']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 13"
                    :icon="['fal', 'browser']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="thirdParty.category.id === 14"
                    :icon="['fal', 'comment-alt-check']"
                    class="text-primary"
                    size="3x"
                  ></font-awesome-icon>
                </span>
              </div>
              <div class="col-sm-10 col-9">
                <div class="pl-2">
                  {{ thirdParty.name }}
                  <p class="small text-muted">
                    {{ thirdParty.category.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>

    <div
      v-if="filteredListBySearch.length === 0"
      class="col-12"
    >
      <div class="my-4 w-100 text-muted text-center">
        Leider konnten wir mit Ihrem angegebenen Filterkriterium keinen Drittdienst finden.
      </div>
    </div>

    <div
      v-if="showHint"
      class="col-12"
    >
      <div class="p-3 mt-4 w-100 bg-white border border-info text-muted rounded">
        Sollte Ihnen in der Liste noch ein Dienst fehlen, wenden Sie sich bitte an unseren <a href="kontakt">Support</a>.
      </div>
    </div>
  </div>
</template>

<script>
import {BLink, BPopover} from 'bootstrap-vue'

export default {
  components: {BLink, BPopover},
  props: {
    thirdParties: {
      type: Array,
      default() {
        return []
      },
    },
    thirdPartyCategories: {
      type: Array,
      default() {
        return []
      }
    },
    showSearch: {
      type: Boolean,
      default() {
        return true
      },
    },
    showHint: {
      type: Boolean,
      default() {
        return true
      },
    },
  },

  data() {
    return {
      search: '',
      categories: [],
    }
  },

  computed: {
    filteredThirdPartiesByCategory() {

      if (this.categories.length === 0) {
        return this.thirdParties;
      }

      let self = this;

      return this.thirdParties.filter(function (thirdParty) {
        let category = self.categories.filter((category) => (thirdParty.third_party_category_id === category.id));
        return category[0].active;
      });
    },

    filteredListBySearch() {
      return this.filteredThirdPartiesByCategory.filter(thirdParty => {
        return thirdParty.name.toLowerCase().includes(this.search.toLowerCase())
      })
    },

  },

  created() {
    this.thirdPartyCategories.forEach((category) => {
      this.categories.push({id: category.id, name: category.name, active: true});
    });
  },

  methods: {
    toggleCategory(category) {
      category.active = !category.active;
    },

    showAll() {
      this.categories.forEach((category) => category.active = true);
    },

    showNone() {
      this.categories.forEach((category) => category.active = false);
    }
  }
}
</script>
